import React from "react";
import styles from "./FinalMixing.module.scss";
import { messages } from "../Workflow.messages";
import { useIntl } from "react-intl";
import { useUi } from "@jelly/lesson";

export const FinalMixing: React.FC = () => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>{formatMessage(messages.finalMixingTitle)}</h3>
      <ui.Scrollbars>
        <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.finalMixingDescription) }}></p>
      </ui.Scrollbars>
    </div>
  );
};
